import { _,helpers, React, ts, ui } from '_core';

import { Params } from './types';

type ChartProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  turnover: string;
  fullScreen: boolean;
  params: Params;
  title: string;
};

const Chart = ({ id, readOnly, fullScreen, loadWidgetData, turnover, params, title }: ChartProps) => {
  const [data, setData] = React.useState<ts.types.widgets.TableData>(null);
  const [error, setError] = React.useState<ts.types.common.ApiError>(null);

  const loadData = async () => {
    try {
      const response = await loadWidgetData({
        data: {
          file: turnover,
        },
      });
      if (response) {
        setData(response.data);
      }
    } catch (err) {
      setError(err as ts.types.common.ApiError);
    }
  };

  React.useEffect(() => {
    if (turnover) loadData();
    return () => setData(null);
  }, [turnover]);

  const formattedData = React.useMemo(() => {
    if (_.isNil(data)) return null;
    return data.map((item) => {
      return {
        ...item,
        build_date: item.build_date.toString(),
      };
    });
  }, [data]);

  return (
    <ui.NestedBarChart
      id={id}
      data={formattedData}
      fullScreen={fullScreen}
      numberFormat="#.##%"
      alert={error ? { type: 'error', message: helpers.parseApiError(error) } : undefined}
      category="build_date"
      exportTitle={title}
      readOnly={readOnly}
      stacked={params.is_total}
    />
  );
};

export default Chart;
